const testimonials = [
  {
    image:
      'https://joybird2.imgix.net/static-v1/pdp-page/press_logo-wirecutter.svg',
    text:
      'Of all the couches we tested, Joybird’s offers the best mix of quality construction, comfort, and price.',
  },
  {
    image:
      'https://joybird2.imgix.net/static-v1/pdp-page/press_logo-NewYorkTimes.svg',
    text:
      'A new breed of online furniture manufacturer offering high-end quality, customization & quick turnaround.',
  },
  {
    image:
      'https://joybird2.imgix.net/static-v1/pdp-page/press_logo-glamour.svg',
    text: 'Joybird is changing the custom furniture game.',
  },
  {
    image:
      'https://joybird2.imgix.net/static-v1/pdp-page/press_logo-elle-decor.svg',
    text:
      'Well-made, customizable seating inspired by Mid-century styles rule the roost at Joybird furniture.',
  },
  {
    image: 'https://joybird2.imgix.net/static-v1/pdp-page/press_logo-r29.svg',
    text:
      "Not only does Joybird offer a range of customizeable mid-century piece, it's an amazing place for design inspo.",
  },
];

export default testimonials;
